// eslint-disable-next-line no-restricted-imports
import { fieldInterface } from './fieldInterface';
import { fieldInterface as fieldInterfaceRegistry } from '@ardoq/field-interface';

export const initializeFieldInterface = () => {
  fieldInterfaceRegistry.registerImplementation(fieldInterface);
};
